import React, { Component } from 'react'

export class NewsItem extends Component {
  render() {
    let {title,description,imageUrl,newsUrl,author,date,source} = this.props;
    return (
      <div className="news-card-wrapper">
        <div className="news-card">
          <div className="news-card-image-wrap">
            <span className="badge news-badge-new">New</span>
            <span className="badge rounded-pill news-badge-source">{source}</span>
            <img
              src={imageUrl ? imageUrl : "https://img.freepik.com/free-vector/gradient-breaking-news-logo-design_23-2151157239.jpg"}
              className="news-card-image"
              alt={title || "News article"}
            />
          </div>
          <div className="news-card-body">
            <h5 className="news-card-title">{title}...</h5>
            <p className="news-card-text">{description.substring(0, 25)}...</p>
            <p className="news-card-meta">
              <small>
                By <strong>{author ? author : "unknown"}</strong>
                <br />
                on {new Date(date).toGMTString()}
              </small>
            </p>
            <a rel="noreferrer" href={newsUrl} target='_blanck' className="btn btn-sm news-read-btn">Read More</a>
          </div>
        </div>
      </div>
    )
  }
}

export default NewsItem


/*
 "new Date(date).toGMTString()"::--it is use to formate a date on gmtstring style
*/
